//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { getContentLibraryAutocomplete } from '@apis/content-library/contentLibraryApi';
import { IContentLibrarySourcesOptions } from '@apis/content-library/contentLibraryApiModel';
import {
  MediaLibrarySearchTagHeaders,
  MediaLibrarySearchTagPrefixes,
} from '@components/media-filters/mediaFilterConstants';
import { QueryKeyConstants } from '@queries/QueryKeyConstants';
import { FIVE_MINUTES_STALE_TIME } from '@queries/QueryOptionsConstants';

export const useAutocompleteUsernamesHashtagsQuery = (
  prefix: string,
  sources: IContentLibrarySourcesOptions,
) => {
  return useQuery({
    queryKey: [
      QueryKeyConstants.MediaFilters,
      QueryKeyConstants.MediaFiltersAutocompleteUsernamesHashtags,
      { prefix, sources },
    ],
    queryFn: ({ signal }) =>
      getContentLibraryAutocomplete(
        { autocompleteType: 'InstagramUsersAndHashtags', prefix, sources },
        { signal },
      ),
    select: ({ hashtags, usernames }) => {
      return {
        hashtags: hashtags.map(({ count, value }) => ({
          count,
          header: MediaLibrarySearchTagHeaders.igHashtags,
          label: value,
          prefix: MediaLibrarySearchTagPrefixes.igHashtags,
        })),
        usernames: usernames.map(({ count, value }) => ({
          count: count,
          header: MediaLibrarySearchTagHeaders.igUsernames,
          label: value,
          prefix: MediaLibrarySearchTagPrefixes.igUsernames,
        })),
      };
    },
    staleTime: FIVE_MINUTES_STALE_TIME,
    placeholderData: keepPreviousData,
  });
};
